/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryCandidatesFilterViewModel } from "../types/MyLibraryCandidatesFilterViewModel.ts";

export const myLibraryCandidatesFilterViewModelSchema = z.object({
  classStudentIds: z
    .array(z.number().int())
    .describe(
      "IDs das turmas a filtrar. Lista vazia significa nenhum filtro de turma. Opcional.",
    )
    .nullish(),
  personIds: z
    .array(z.number().int())
    .describe(
      "IDs das pessoas a filtrar. Lista vazia significa nenhum filtro de pessoa. Opcional.",
    )
    .nullish(),
  hasAnyFilter: z.optional(
    z
      .boolean()
      .describe(
        "Somente leitura. Indica se ao menos um dos dois filtros foi informado — é obrigatório informar pelo menos um.",
      ),
  ),
}) as unknown as ToZod<MyLibraryCandidatesFilterViewModel>;
